let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bw2mg")).then(() => parcelRequire('7lKQU'));